import { Injectable, computed, effect, signal } from '@angular/core';
import { AppSettings } from './app.settings';
import { ThemingService } from './theming.service';
import { LocalStorageService } from './localstorage.service';
import { IAppState } from '../types/infrastructure/interfaces/IAppState';
import { IUrlSegment } from '../types/infrastructure/interfaces/IUrlSegment';

@Injectable({
  providedIn: 'root'
})
export class AppstateService {

  public projekteTreeInit = signal<boolean>(false);
  public archivTreeInit = signal<boolean>(false);
  
  public projektId = signal<number|null>(null);
  public projektantragInit = signal(false);
  public projektFilter = signal<string>('');
  public budgetantragId = signal<number|null>(null);
  public budgetantragPreissteigerungId = signal<number|null>(null);
  public projektInfoId = signal<number|null>(null);
  public projektName = signal<string>('');

  public sidenavExpanded = signal(true);
  public sidepanelInfoExpanded = signal(false);
  public sidepanelHistoryExpanded = signal(false);

  public navigationPlangebiet = signal('ALLE');
  public navigationMain = signal('projekte');
  public navigationBereich = signal<string|null>('alle');
  public navigationBearbeitung = signal<string|null>('alle');
  public navigationUrl = signal('/projekte');
  public navigationSegements = signal<IUrlSegment[]>([{name: 'ALLE', url: 'projekte'}]);
  public navigationAssistentPosition = signal(0);
  public navigationAssistentShow = signal(false);
  public navigationAssistentUrl = signal('');

  public isDarkMode = signal(false);
  public gridStateProjekte = signal<string>('');
  public gridStateArchiv = signal<string>('');
  public isBauControlling = computed<boolean>(() => this.navigationBereich() == "Bau");  
  public isInitialized = signal(false);

  constructor(private appSettings: AppSettings,
              private localStorageService: LocalStorageService) { 

    effect(() => {

      // NavigationSettings
      AppSettings.appState.navigationPlangebiete = this.navigationPlangebiet();
      AppSettings.appState.navigationMain = this.navigationMain();
      AppSettings.appState.navigationBereich = this.navigationBereich();
      AppSettings.appState.navigationBearbeitung = this.navigationBearbeitung();
      //AppSettings.appState.navigationUrl = this.navigationUrl();
      AppSettings.appState.projektFilter = this.projektFilter();
      // SidenavSettings
      AppSettings.appState.sidenavExpanded = this.sidenavExpanded();
      AppSettings.appState.sidepanelExpanded = this.sidepanelInfoExpanded();
      AppSettings.appState.sidepanelHistoryExpanded = this.sidepanelHistoryExpanded();
      // AssistentSettings
      AppSettings.appState.navigationAssistentShow = this.navigationAssistentShow();
      AppSettings.appState.navigationAssistentUrl = this.navigationAssistentUrl();
      AppSettings.appState.navigationAssistentPosition = this.navigationAssistentPosition();
      // DataSettings
      //AppSettings.appState.projektId = this.projektId();
      //AppSettings.appState.budgetantragId = this.budgetantragId();
      //AppSettings.appState.projektInfoId = this.projektInfoId();
      // ThemingSettings
      AppSettings.appState.isDarkMode = this.isDarkMode();
      // GridState
      AppSettings.appState.gridStateProjekte = this.gridStateProjekte();
      AppSettings.appState.gridStateArchiv = this.gridStateArchiv();
      // Persist AppState to LocalStorage, only after initialization
      if (this.isInitialized()) {
        this.localStorageService.setAppState(AppSettings.appState);
      }
    });
  }

  initAppStateFromLocalStorage() {
    const stateLocalStorage = this.localStorageService.getAppState();
    if (stateLocalStorage) {
      this.initAppState(stateLocalStorage);
      }
	this.isInitialized.set(true);
  }

  initAppState(appState: IAppState) {
    AppSettings.appState = appState;

    // NavigationSettings
    this.navigationPlangebiet.set(appState.navigationPlangebiete);
    this.navigationMain.set(appState.navigationMain);
    this.navigationBereich.set(appState.navigationBereich);
    this.navigationBearbeitung.set(appState.navigationBearbeitung);
    //this.navigationUrl.set(appState.navigationUrl);
    this.projektFilter.set(appState.projektFilter);
    // SidenavSettings
    this.sidenavExpanded.set(appState.sidenavExpanded);
    this.sidepanelInfoExpanded.set(appState.sidepanelExpanded);
    this.sidepanelHistoryExpanded.set(appState.sidepanelHistoryExpanded);
    // AssistentSettings
    this.navigationAssistentPosition.set(appState.navigationAssistentPosition);
    this.navigationAssistentShow.set(appState.navigationAssistentShow);
    this.navigationAssistentUrl.set(appState.navigationAssistentUrl);
    // DataSettings
    //this.projektId.set(appState.projektId);
    //this.budgetantragId.set(appState.budgetantragId);
    //this.projektInfoId.set(AppSettings.appState.projektInfoId);
    // ThemingSettings
    this.isDarkMode.set(appState.isDarkMode);
    // GridState
    this.gridStateProjekte.set(appState.gridStateProjekte);
    this.gridStateArchiv.set(appState.gridStateArchiv);
  }

  resetProjektListe() {
    var navigationBearbeitung = this.navigationBearbeitung();
    this.navigationBearbeitung.set(null);
    this.navigationBearbeitung.set(navigationBearbeitung);
  }

  resetProjektAndBudgetarchivListe() {
    var navigationBereich = this.navigationBereich();
    this.navigationBereich.set(null);
    this.navigationBereich.set(navigationBereich);
  }

  resetProjektDetails() {
    var projektId = this.projektId();
    this.projektId.set(null);
    this.projektId.set(projektId);
  }

  resetProjektInfo() {
    var projektInfoId = this.projektInfoId();
    this.projektInfoId.set(null);
    this.projektInfoId.set(projektInfoId);
  }

}
